import { ILayer } from '../layer.type';
import { environment } from '../../../../../environments/environment';
import { getCSSColorVariableValue } from '../../../utils';
import { _ } from '../../../utils';
import { getSharedLayer } from './shared';

const SYKE_ATTRIBUTION =
  '<a href="https://www.syke.fi/avointieto" target="_blank">SYKE</a>';

const sharedLayers = [
  getSharedLayer('rails'),
  getSharedLayer('levelcrossings'),
  getSharedLayer('trafficControlPoints'),
  getSharedLayer('intersectionStations'),
  getSharedLayer('contour'),
  getSharedLayer('depthContour'),
  getSharedLayer('groundWaterAreas'),
  getSharedLayer('drainageAreas'),
  getSharedLayer('basinOutlets'),
  getSharedLayer('houseNumbers')
];

// vectorURL and vectorSourceLayer are filled in from encrypted-data/T14.json by MapService.addLayer
export default function getLayers(): ILayer[] {
  return [
    {
      id: 'Kaivo',
      name: _('Manhole'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'symbol',
        sourceType: 'vector',
        clickable: true,
        icon: {
          url: environment.assetRoot + '/img/rego/circle-dark-brown.png',
          opacity: 0.8,
        },
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji'],
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    {
      id: 'Kaivonkansi',
      name: _('Manhole cover'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'symbol',
        sourceType: 'vector',
        clickable: true,
        icon: {
          url: environment.assetRoot + '/img/rego/circle-brown.png',
          opacity: 0.8,
        },
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji'],
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    {
      id: 'Karttapiste',
      name: _('Subsurface drain well'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'symbol',
        sourceType: 'vector',
        clickable: true,
        icon: {
          url: environment.assetRoot + '/img/rego/circle-dark-brown.png',
          opacity: 0.8,
        },
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji'],
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    {
      id: 'Karttaviiva',
      name: _('Subsurface drain network'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'line',
        sourceType: 'vector',
        clickable: true,
        strokeColor: getCSSColorVariableValue('info-base'),
        strokeWeight: 1,
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji'],
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    {
      id: 'Kasettiventtiili',
      name: _('Cassette valve'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'symbol',
        sourceType: 'vector',
        clickable: true,
        icon: {
          url: environment.assetRoot + '/img/rego/circle-blue.png',
          opacity: 0.8,
        },
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji'],
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    {
      id: 'Kaukolampoventtiili',
      name: _('District heating valve'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'symbol',
        sourceType: 'vector',
        clickable: true,
        icon: {
          url: environment.assetRoot + '/img/rego/circle-green.png',
          opacity: 0.8,
        },
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji'],
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    {
      id: 'Kayttopaikka',
      name: _('Place of use'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'symbol',
        sourceType: 'vector',
        clickable: true,
        icon: {
          url: environment.assetRoot + '/img/rego/circle-brown.png',
          opacity: 0.8,
        },
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji'],
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    {
      id: 'Liittyma',
      name: _('Connection'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'symbol',
        sourceType: 'vector',
        clickable: true,
        icon: {
          url: environment.assetRoot + '/img/rego/circle-green.png',
          opacity: 0.8,
        },
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji'],
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    {
      id: 'Paisuntasailio',
      name: _('Expansion tank'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'symbol',
        sourceType: 'vector',
        clickable: true,
        icon: {
          url: environment.assetRoot + '/img/rego/circle-blue.png',
          opacity: 0.8,
        },
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji'],
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    {
      id: 'Pumppu',
      name: _('Pump'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'symbol',
        sourceType: 'vector',
        clickable: true,
        icon: {
          url: environment.assetRoot + '/img/rego/circle-blue.png',
          opacity: 0.8,
        },
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji'],
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    {
      id: 'Pumppuasema',
      name: _('Pump station'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'symbol',
        sourceType: 'vector',
        clickable: true,
        icon: {
          url: environment.assetRoot + '/img/rego/circle-green.png',
          opacity: 0.8,
        },
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji'],
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    {
      id: 'Putki',
      name: _('District heating network'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'line',
        sourceType: 'vector',
        clickable: true,
        strokeColor: getCSSColorVariableValue('success-base'),
        strokeWeight: 1,
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji'],
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    {
      id: 'Solmupiste',
      name: _('Node'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'symbol',
        sourceType: 'vector',
        clickable: true,
        icon: {
          url: environment.assetRoot + '/img/rego/circle-green.png',
          opacity: 0.8,
        },
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji'],
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    {
      id: 'Syottopiste',
      name: _('Feed point'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'symbol',
        sourceType: 'vector',
        clickable: true,
        icon: {
          url: environment.assetRoot + '/img/rego/circle-blue.png',
          opacity: 0.8,
        },
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji'],
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    {
      id: 'Tasain',
      name: _('Regulator'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'symbol',
        sourceType: 'vector',
        clickable: true,
        icon: {
          url: environment.assetRoot + '/img/rego/circle-green.png',
          opacity: 0.8,
        },
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji'],
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    {
      id: 'Tekstipiste',
      name: _('Text point'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'symbol',
        sourceType: 'vector',
        clickable: true,
        icon: {
          url: environment.assetRoot + '/img/rego/circle-green.png',
          opacity: 0.8,
        },
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji'],
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    {
      id: 'Verkostopiste',
      name: _('Network point'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'symbol',
        sourceType: 'vector',
        clickable: true,
        icon: {
          url: environment.assetRoot + '/img/rego/circle-green.png',
          opacity: 0.8,
        },
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji'],
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    ...sharedLayers
  ];
}
